export const dashboard = {
  title: "Painel intuitivo",
  subtitle:
    "Gerencie todas as suas trocas a partir de uma interface simples e moderna",
  features: {
    stats: {
      title: "Estatísticas detalhadas",
      description:
        "Acompanhe seus Noites, trocas e economias realizadas em tempo real",
    },
    notifications: {
      title: "Notificações inteligentes",
      description: "Receba alertas para novos pedidos e mensagens importantes",
    },
    management: {
      title: "Gestão simplificada",
      description:
        "Gerencie suas disponibilidades, reservas e trocas em alguns cliques",
    },
  },
  cta: "Descobrir o painel",
  exchangeConfirmed: "Troca confirmada",
  newRequests: "novos pedidos",
  toReview: "Para analisar",
};
